//also is set in Variables.pug, these should match
const emailvalidationPattern = /^.+@[^@]+\.[^@]+$/;
const emailvalidChars = /[^A-Za-z0-9\+\.@_~-]+/;
const OneAt = /@{1}/;
const domainvalidationPattern = /^[\da-zA-Z][\da-zA-Z-]+$/;
const fqdnvalidationPattern = /^((?!-)[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]\.)+[a-zA-Z]{2,63}$/;
// https://stackoverflow.com/questions/11809631/fully-qualified-domain-name-validation - fqdnvalidation patter
// **Note, see EDIT2 and use the JS version with no lookbehind**
//ala https://gist.github.com/dperini/729294 3/9/2022 decided to not use it because I want localhost
//https://mathiasbynens.be/demo/url-regex - picked @stephenhay because it was simple and allowed localhost
//https://css-tricks.com/form-validation-part-1-constraint-validation-html/
/*eslint-disable-next-line*/
//const urlvalidationPattern = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/;
const urlvalidationPattern = /^https?:\/\/[^\s\/$.?#].[^\s]*$/;


function validateFQDN(domain) {
  
  /*eslint-disable-next-line*/
  const re = new RegExp(fqdnvalidationPattern);
  return (domain.length <= 255 && re.test(String(domain)));
}

function validateEmail(email) {
  //https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
  /*eslint-disable-next-line*/
  //https://haacked.com/archive/2007/08/21/i-knew-how-to-validate-an-email-address-until-i.aspx/ comment from Bill Weiss

  let invalid = false;
  
  const reChar = new RegExp(emailvalidChars);
  const rePattern = new RegExp(emailvalidationPattern);
  const reOneAt = new RegExp(OneAt);
  invalid = invalid || (email.length > 320);
  invalid = invalid || !rePattern.test(String(email));
  invalid = invalid || reChar.test(String(email));
  invalid = invalid || !reOneAt.test(String(email));
  invalid = invalid || !validateFQDN(email.split("@")[1]);
  return !invalid;
}

function validateDomain(domain) {
  
  /*eslint-disable-next-line*/
  const re = new RegExp(domainvalidationPattern);
  return (domain.length <= 63 && re.test(String(domain)));
}



function validateURL(URL) {
  

  /*eslint-disable-next-line*/
  const re = new RegExp(urlvalidationPattern);
  
  return (URL.length <= 2048 && re.test(String(URL)));
}

export { validateURL }
export { validateFQDN }
export default { validateEmail, validateDomain }

